import React from 'react';
import PropTypes from 'prop-types';
import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { colorStyles, sizeStyles, baseButtonStyle } from './style/buttonStyle';

const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    ![
      'color',
      'round',
      'fullWidth',
      'customClass',
      'right',
      'btnMessages',
      'justIcon',
      'wd',
      'noBorder',
      'resetPadding',
      'size',
    ].includes(prop),
})(({ color, round, fullWidth, right, justIcon, wd, btnMessages, noBorder, resetPadding, size, disabled }) => ({
  ...baseButtonStyle,
  ...(color && colorStyles[color]),
  ...(round && { borderRadius: '9999px' }),
  ...(fullWidth && { width: '100%', paddingLeft: 0, paddingRight: 0 }),
  ...(disabled && { opacity: '0.65', cursor: 'not-allowed' }),
  ...(right && { float: 'right' }),
  ...(justIcon && { minWidth: '10px', paddingLeft: '12px', paddingRight: '12px', fontSize: '20px' }),
  ...(wd && { minWidth: '160px' }),
  ...(size && sizeStyles[size]),
  ...(btnMessages && { marginRight: 25 }),
  ...(noBorder && {
    border: 'none !important',
    boxShadow: 'none',
    '&:hover,&:focus': { border: 'none !important', boxShadow: 'none' },
  }),
  ...(resetPadding && { padding: '8px 16px' }),
}));

function RegularButton({ children, customClass, sx, ...rest }) {
  return (
    <StyledButton sx={customClass ? { ...customClass } : sx} {...rest}>
      {children}
    </StyledButton>
  );
}

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'orange',
    'lightGray',
    'defaultNoBackground',
    'primaryNoBackground',
    'infoNoBackground',
    'successNoBackground',
    'warningNoBackground',
    'dangerNoBackground',
    'defaultBordered',
    'primaryBordered',
    'white',
  ]),
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  customClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  right: PropTypes.bool,
  wd: PropTypes.bool,
  justIcon: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'xs']),
  noBorder: PropTypes.bool,
  resetPadding: PropTypes.bool,
  onClick: PropTypes.func,
  sx: PropTypes.object,
};

export default RegularButton;
